

















































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Contexts } from "@/models/contexts";
import { GrantTypes } from "@/data/enums/tokens";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";

@Component
export default class SessionExpiredModal extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public context!: Contexts;
  @Prop({ required: true })
  public email!: string;
  // Data
  public declare $refs: {
    password: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };
  public form: { email: string; password: string } = {
    email: "",
    password: ""
  };
  public isProcessing = false;

  // Getters
  public get isImpersonating() {
    return this.$store.getters["auth/isImpersonating"](this.context);
  }

  private get isAuthenticated() {
    return this.$store.getters[`auth/${this.context}/isAuthenticated`];
  }

  // Life-cycle Methods
  public created() {
    this.form.email = this.email;
  }

  public mounted() {
    this.$nextTick(() => {
      if (!this.isImpersonating) {
        // this throws Cannot read property '$el' of undefined"
        this.$refs.password.$el.querySelector("input").focus();
      }
    });
  }

  // Watchers
  @Watch("isAuthenticated")
  private onAuthChange(isAuthenticated) {
    // Re-authenticated in another tab
    if (isAuthenticated) this.$emit("success");
  }

  // Methods
  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate().then(result => {
      if (result) {
        return this.$store
          .dispatch(`auth/${this.context}/reauthenticate`, {
            username: this.form.email,
            password: this.form.password,
            grant_type:
              this.context === Contexts.ADMIN
                ? GrantTypes.ADMIN
                : GrantTypes.PASSWORD
          })
          .then(() => {
            this.$emit("success");
          })
          .catch(error => {
            this.isProcessing = false;
            if (error !== "cancelled") {
              this.validationErrors["password"].push(
                this.$_.get(error, "response.data.error.message", "")
              );
            }
          });
      }
      this.isProcessing = false;
      this.$buefy.toast.open({
        message: this.$t("_sentence.form_is_not_valid") as string,
        type: "is-danger"
      });
    });
  }
}
